import React from 'react';
import Backend from '../../../Layouts/Backend';
import { FormGroup, Label, FormFeedback } from 'reactstrap';
import TouchableOpacity from '../../../UI/TouchableOpacity';
import LoadingButton from '../../../UI/LoadingButton';
import { Formik } from 'formik';
import { validationSchema } from './validation';
import { withTranslation } from 'react-i18next';
import { Input, Alert } from '../../../UI/Common';
import helper from '../../../../utils/helper';
import PasswordConfirmation from '../../../UI/PasswordConfirmation';

const helperCharacters = ['˚', 'µ', '²', '³'];
const UnitForm = (props) => {
  const form = {
    units: '',
    scale: '',
    offset: '',
    description: '',
    focus: '',
    focusError: false,
  };
  const [state, setState] = React.useState({
    focus: '',
    focusError: false,
  });
  const handleFocus = (e) => {
    setState({
      ...state,
      focus: e.target.id,
    });
  };
  const handleBlur = () => {
    setState({
      ...state,
      focus: '',
    });
  };
  const addSpecialCharacter = (character, setFieldValue, values) => {
    const { focus } = state;
    if (focus) {
      const currentValue = values[focus];
      const el = document.getElementById(focus);
      const start = el.selectionStart;
      const end = el.selectionEnd;
      const text = currentValue;
      const before = text.substring(0, start);
      const after = text.substring(end, text.length);
      setState({ ...state, focusError: false });
      setFieldValue(focus, before + character + after);
      el.selectionStart = el.selectionEnd = start + character.length;
      // console.log(el.selectionStart);
    } else {
      setState({ ...state, focusError: true });
    }
  };
  const { t, loading, initialValues = {} } = props;
  const [openModal, setOpenModal] = React.useState(false);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onSubmit(values) {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      props.onSubmit(values);
    }
  }
  function getTitle() {
    if (!props.isCreate) return `Edit Unit: ${initialValues.units || ''}`;
  }
  return (
    <Backend title={getTitle()}>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => onSubmit(values)}
      >
        {({
          values,
          handleChange,
          errors,
          touched,
          handleSubmit,
          setFieldValue,
        }) => {
          return (
            <div className="content-inner">
              <PasswordConfirmation
                isOpen={openModal}
                onCancel={() => setOpenModal(false)}
                onConfirm={() => {
                  setOpenModal(false);
                  props.onSubmit(values);
                }}
              />
              <div className="row">
                <div className="p-0 col-4">
                  <Input
                    required
                    label="Units"
                    id="units"
                    onChange={handleChange('units')}
                    value={values.units}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    invalid={touched.units && errors.units}
                    error={errors.units}
                  />
                  <Input
                    required
                    label="Scale"
                    id="scale"
                    onChange={handleChange('scale')}
                    value={values.scale}
                    invalid={touched.scale && errors.scale}
                    error={errors.scale}
                  />
                  <Input
                    required
                    label="Offset"
                    id="offset"
                    onChange={handleChange('offset')}
                    value={values.offset}
                    invalid={touched.offset && errors.offset}
                    error={errors.offset}
                  />
                  <Input
                    required
                    label="Description"
                    id="description"
                    onChange={handleChange('description')}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    value={values.description}
                    invalid={touched.description && errors.description}
                    error={errors.description}
                  />
                </div>
                <div className="p-0 col-4">
                  <FormGroup>
                    <Label htmlFor="helper">{t('Helper')}</Label>
                    {helperCharacters.map((char, index) => (
                      <HelperBtn
                        key={char}
                        name={char}
                        onClick={() =>
                          addSpecialCharacter(char, setFieldValue, values)
                        }
                      />
                    ))}
                    {state.focusError && (
                      <FormFeedback>Please focus on text field</FormFeedback>
                    )}
                  </FormGroup>
                </div>
              </div>
              <Alert.Error text={props.errors} />
              <LoadingButton
                id="new-unit-btn"
                classes="button button-primary mt-20"
                loading={loading}
                onClick={handleSubmit}
              >
                {t(props.isCreate ? 'Create' : 'Save')}
              </LoadingButton>
            </div>
          );
        }}
      </Formik>
    </Backend>
  );
};
// class UnitForm extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       units: '',
//       scale: '',
//       offset: '',
//       description: '',
//       focus: '',
//       focusError: false,
//     };
//   }
//   handleFocus = (e) => {
//     this.setState({
//       focus: e.target.id,
//     });
//   };
//   handleBlur = () => {
//     this.setState({
//       focus: '',
//     });
//   };
//   addSpecialCharacter = (character, setFieldValue, values) => {
//     const { focus } = this.state;
//     if (focus) {
//       const currentValue = values[focus];
//       this.setState({ focusError: false }, () =>
//         setFieldValue(focus, currentValue + character),
//       );
//     } else {
//       this.setState({ focusError: true });
//     }
//   };
//   render() {
//     const { t, loading, initialValues = {}, onSubmit } = this.props;
//   }
// }

const HelperBtn = ({ onClick, name, ...props }) => {
  return (
    <TouchableOpacity className="btn-touch" onClick={onClick}>
      {name}
    </TouchableOpacity>
  );
};
export default withTranslation('app')(UnitForm);
